/* eslint-disable no-use-before-define */
import React, { useEffect, useMemo, useState } from 'react';
import operationTypesRealNames from 'constants/operationTypesRealNames';
import { useTranslate } from 'hooks/useTranslate';
import { getOperationTypes } from 'modules/transactions/api/getOperationTypes';
import { operationList } from 'modules/transactions/constants/operationList';

type OperationTypesSelectorProps = {
  societyId: string | undefined;
  filterBy: string;
  onChangeFilter: (filterBy: string) => void; // eslint-disable-line
};

interface FilterIconProps {
  isFiltered: boolean;
}

const FilterIcon = ({ isFiltered }: FilterIconProps) => (
  <div className="form-icon form-icon-left">
    <em className={`icon ni ni-filter${isFiltered ? '-fill' : ''}`} />
  </div>
);

const OperationTypesSelector = ({
  societyId,
  filterBy,
  onChangeFilter,
}: OperationTypesSelectorProps) => {
  const { t } = useTranslate();
  const [availableOperations, setAvailableOperations] = useState<string[]>([]);

  const handleChangeFilter = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChangeFilter?.(event.target.value);
  };

  useEffect(() => {
    const fetchOperations = async () => {
      if (!societyId) return;

      try {
        const data = (await getOperationTypes(societyId)) as string[];

        setAvailableOperations(data);
      } catch (error) {
        setAvailableOperations([]);
      }
    };

    fetchOperations();
  }, [societyId]);

  const filteredOperations = useMemo(
    () =>
      operationList.filter(
        (operation) =>
          availableOperations.includes(operation) || operation === 'ALL'
      ),
    [availableOperations]
  );

  if (!societyId) {
    return null;
  }

  return (
    <div className="form-group">
      <div className="form-control-wrap">
        <div className="form-control-select">
          <FilterIcon isFiltered={filterBy !== 'ALL'} />
          <select
            className="form-control pr-4 cursor-pointer"
            id="filter-society"
            name="filter-society"
            value={filterBy}
            onChange={handleChangeFilter}
            aria-label="Select operation type"
          >
            {filteredOperations.map((operation, index) => (
              <option key={operation} value={operation}>
                {index === 0 ? t('All') : t(operationTypesRealNames[operation])}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default OperationTypesSelector;
